/** KONDITIONEN display labels for SHV factsheets (shared template structure). */
export const KONDITIONEN_TER_FORM_LABEL = 'TER²';

export const KONDITIONEN_TER_ROW_LABEL = 'TER²:';

export function getKonditionenRowLabel(fieldKey: string, defaultLabel: string): string {
  if (fieldKey === 'ter_2022') return KONDITIONEN_TER_ROW_LABEL;
  return defaultLabel;
}

/** DataTable / preview key column (without trailing colon). */
export function getKonditionenDisplayKey(fieldKey: string): string {
  if (fieldKey === 'ter_2022') return KONDITIONEN_TER_FORM_LABEL;
  return fieldKey;
}
